import { type TransformedCartData } from "~/features/cart/cart/transformers/CartResponseTransformer";
import { CART_LOAD_START, CART_LOAD_SUCCESS, CART_LOAD_FAIL } from "./actions/actionTypes";

export { CART_LOAD_START, CART_LOAD_SUCCESS, CART_LOAD_FAIL };

export function cartLoadStartAction() {
  return {
    type: CART_LOAD_START,
  } as const;
}

export function cartLoadFinishAction(data: TransformedCartData) {
  return {
    type: CART_LOAD_SUCCESS,
    payload: data,
  } as const;
}

export function cartLoadErrorAction() {
  return {
    type: CART_LOAD_FAIL,
  } as const;
}
